const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Request payload for the weekly-report details endpoint. */
export interface WeeklyReportParams {
  compliance_type: 'S' | 'I';
  customer_id: string;
  report_type: string;
  requested_date: string;
  user_id: string;
}

/**
 * Formats a date as `DD-Mon-YYYY` (e.g. `05-Oct-2026`), the format the weekly-report API expects.
 * @param today - The date to format.
 * @returns The formatted date string.
 */
export function formatWeeklyRequestDate(today: Date): string {
  const day = String(today.getDate()).padStart(2, '0');
  return `${day}-${MONTH_NAMES[today.getMonth()]}-${today.getFullYear()}`;
}

/**
 * Builds the weekly-report details request payload.
 * @param complianceType - `'S'` for statutory, `'I'` for internal.
 * @param customerId - Customer id sent with the request.
 * @param userId - User id sent with the request.
 * @param reportFlag - Report type requested (e.g. `Comprehensive`).
 * @param requestedDate - Explicit requested date; today's date is used when empty.
 * @param today - Current date, injectable for tests.
 * @returns The request payload, keys in the order the API has always received them.
 */
export function buildWeeklyReportParams(
  complianceType: 'S' | 'I',
  customerId: string,
  userId: string,
  reportFlag: string,
  requestedDate: string,
  today: Date = new Date()
): WeeklyReportParams {
  return {
    compliance_type: complianceType,
    customer_id: customerId,
    report_type: reportFlag,
    requested_date: requestedDate ? requestedDate : formatWeeklyRequestDate(today),
    user_id: userId
  };
}
